interface HiddenFormParams {
  url: string;
  method?: 'POST' | 'GET';
  target?: string;
  data: Record<string, string | number | boolean | string[]>;
}

export function submitHiddenFormInReports({
  url,
  target = '_blank',
  method = 'POST',
  data,
}: HiddenFormParams) {
  const form = document.createElement('form');
  form.method = method;
  form.action = url;
  form.target = target;

  Object.entries(data).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;

    if (Array.isArray(value)) {
      input.value = value.join(',');
    } else {
      input.value = String(value ?? '');
    }

    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
